<template>
    <v-dialog :value="filterForm.modalType === 'campaign'" max-width="1200" persistent>
        <v-card class="text-center form-campaign">
            <v-card-title style="padding: 10px 24px;background: #006CD0;color: white" class="align-center font-weight-bold px-4">
                CÀI ĐẶT BOT CALL
                <v-icon color="white" aria-label="Close" @click="$emit('closeModal')">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="pa-4">
                <div class="d-flex  justify-end">
                    <v-btn style="margin-right: 0 !important;" color="#006CD0" @click="createData">  <v-icon>mdi-plus</v-icon> Thêm cài đặt</v-btn>
                </div>
                <div>
                    <v-data-table
                            class="mt-4 table-campaign"
                            :fixed-header="true"
                            :disable-sort="true"
                            disable-pagination
                            :height="dataTable.length > 5 ? '450px' : ''"
                            hide-default-footer
                            :headers="headers"
                            :items="dataTable"
                            hide-selected
                    >
                        <template v-slot:item.callCenterId="{ item }">
                            <template v-if="!item.isEdit">
                                {{ item.callCenterId ? listSwitchBoard.find(data => data.id == item.callCenterId).name : '' }}
                            </template>
                            <template v-else>
                                <v-select
                                        style="margin-top: -20px !important;"
                                        v-model="item.callCenterId"
                                        :items="listSwitchBoard"
                                        item-text="name"
                                        item-value="id"
                                        label=""
                                        placeholder="Chọn tổng đài"
                                        hide-details
                                        :menu-props="{ top: true, offsetY: true , maxHeight: 200}"
                                        @change="changeSwitchBoard(item)"
                                />
                            </template>
                        </template>
                        <template v-slot:item.expectedQuantity="{ item }">
                            <template v-if="!item.isEdit">
                                {{ item.expectedQuantity }}
                            </template>
                            <template v-else>
                                <v-text-field
                                        type="number"
                                        v-model="item.expectedQuantity"
                                        class="ma-0 pa-0"
                                        color="primary"
                                        min="1"
                                        max="40000"
                                        step="1"
                                        @input="changeExpectedQuantity(item)"
                                />
                            </template>
                        </template>
                        <template v-slot:item.scriptName="{ item }">
                            <template v-if="!item.isEdit">
                                {{ item.scriptName}}
                            </template>
                            <template v-else>
                                <v-autocomplete
                                        :items="listCampaign"
                                        item-value="id"
                                        item-text="name"
                                        v-model="item.scriptId"
                                        :menu-props="{ bottom: true, maxHeight: 250 }"
                                        @change="changeScriptName(item)"
                                ></v-autocomplete>
                            </template>
                        </template>
                        <template v-slot:item.numPerCall="{ item }">
                            <template v-if="!item.isEdit">
                                {{ item.numPerCall ?  item.numPerCall : '-'}}
                            </template>
                            <template v-else>
                                <v-select
                                  :items="item.callCenterId == 5 ? listNumPerCall: listNumPerCallMinhPhuc"
                                  item-value="value"
                                  item-text="value"
                                  :readonly="item.callCenterId == 3 || item.callCenterId == ''"
                                  v-model="item.numPerCall"
                                  :menu-props="{ bottom: true, maxHeight: 250 }"
                                ></v-select>
                            </template>
                        </template>
                        <template v-slot:item.startDate="{ item }">
                            <template v-if="!item.isEdit">
                                {{ formatDateVN(item.startDate) }}
                            </template>
                            <template v-else>
                                <v-menu
                                        :ref="'datePickerMenu'+dataTable.indexOf(item)"
                                        v-model="datePickerMenu[dataTable.indexOf(item)]"
                                        :close-on-content-click="false"
                                        :return-value.sync="item.startDate"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">

                                        <v-text-field
                                                class="text-field-date-order"
                                                placeholder="--"
                                                style="margin-left: -4px;padding-top: 0 !important;margin-top: 0 !important;"
                                                v-model="item.startDate"
                                                color="primary"
                                                prepend-icon="mdi-calendar-outline"
                                                readonly
                                                v-on="on"
                                                clearable
                                        />
                                    </template>
                                    <v-date-picker
                                            v-model="item.startDate"
                                            color="secondary"
                                            scrollable
                                            @change="changeData(item)"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </template>

                        </template>
                        <template v-slot:item.startTime="{ item }">
                            <template v-if="!item.isEdit">
                                {{ item.startTime }}
                            </template>
                            <template v-else>
                                <v-autocomplete
                                        :items="getListTime(item.endTime)"
                                        item-value="id"
                                        item-text="name"
                                        v-model="item.startTime"
                                        :menu-props="{ bottom: true, maxHeight: 250 }"
                                        clearable
                                />
                            </template>
                        </template>
                        <template v-slot:item.endTime="{ item }">
                            <template v-if="!item.isEdit">
                                {{ item.endTime }}
                            </template>
                            <template v-else>
                                <v-autocomplete
                                        :items="getListTime(item.startTime, 'end')"
                                        item-value="id"
                                        item-text="name"
                                        v-model="item.endTime"
                                        :menu-props="{ bottom: true, maxHeight: 250 }"
                                        clearable
                                />
                            </template>
                        </template>
                        <template v-slot:item.segmentCode="{ item }">
                            <template v-if="!item.isEdit">
                                {{ item.segmentId == 0 ? "Tất cả" :  listSegment.find(segment => segment.id == item.segmentId).segmentCode }}
                            </template>
                            <template v-else>
                                <v-autocomplete
                                  :items="listSegment"
                                  item-value="id"
                                  item-text="segmentCode"
                                  v-model="item.segmentId"
                                  :menu-props="{ bottom: true, maxHeight: 250 }"
                                ></v-autocomplete>
                            </template>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <span v-if="checkTime(item)  && item.id" style="color:#FFB800;font-weight: 500" >Đang chờ</span>
                            <span v-if="!checkTime(item) && item.id" style="color:#0088FF;font-weight: 500" >Đã chạy</span>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <div v-if="item.isEdit" class="d-flex" style="column-gap: 10px;">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div  @click.prevent="updateRow(item)" style=" cursor: pointer;margin-top: 3px" v-on="on">
                                            <v-img width="18"  src="@/assets/create.svg" />
                                        </div>
                                    </template>
                                    <span>Tạo chiến dịch</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div @click.prevent="cancelUpdate(item)"  style="cursor: pointer;margin-top: 3px" v-on="on">
                                            <v-img width="18"  src="@/assets/cancel.svg" />
                                        </div>
                                    </template>
                                    <span>Hủy</span>
                                </v-tooltip>
                            </div>
                            <!--            end -->
                            <div v-if="!item.isEdit && checkTime(item)" class="d-flex align-center justify-center" style="column-gap: 10px;">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div @click.prevent="removeRow(item)"  style="cursor: pointer;margin-top: 3px" v-on="on">
                                            <v-img width="16"  src="@/assets/delete.svg" />
                                        </div>
                                    </template>
                                    <span>Xóa chiến dịch</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </div>
              <div class="mt-2">
                <v-pagination
                    color="#006cd0"
                    class="justify-end"
                    v-if="totalItem > listQuery.limit"
                    v-model="listQuery.page"
                    :length="getTotalItem(totalItem,listQuery.limit)"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                ></v-pagination>
              </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory";
import TokenService from "@/helpers/token";
import * as moment from "moment";

const ContactRepository = RepositoryFactory.get('contact');
const TypeRepository = RepositoryFactory.get('type');
const formData = {
  id: '',
  callCenterId: '', // tong dai
  // typeId: '',  module
  //  schoolLevelId: '',  nhóm ngành THCS, THPT
  expectedQuantity: '',     // số lượng cts
  scriptId: "", // kịch bản
  scriptName: "", // kịch bản
  startDate: "",
  startTime: "",
  endTime: "",
  numPerCall: "",
  segmentId: 0,
  isEdit: true
}
export default {
  props: {
    filterForm: {
      default: () => ({})
    },
    module: {
      default: () => ({})
    }
  },
  data() {
    return {
      totalItem: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      datePickerMenu: [],
      headers: [
        { text: 'Tổng đài', value: 'callCenterId', width: '110px'},
        { text: 'Số lượng contacts', value: 'expectedQuantity', width: '135px', align: 'center'},
        { text: 'Kịch bản', value: 'scriptName'},
        { text: 'CCU', value: 'numPerCall',  width: '80px', align: 'center'},
        { text: 'Ngày gọi', value: 'startDate',  width: '160px', align: 'center'},
        { text: 'Bắt đầu', value: 'startTime', width: '110px', align: 'center' },
        { text: 'Kết thúc', value: 'endTime', width: '110px', align: 'center'},
        { text: 'Tệp KH', value: 'segmentCode', width: '180px'},
        { text: 'Trạng thái', value: 'status', width: '100px'},
        { text: 'Thao tác', value: 'action', width: '80px', align: 'center'},
      ],
      dataTable: [],
      listCampaign: [],
      listSegment: [],
      listSwitchBoard: [
        {
          id: 5,
          name: 'Omicall'
        },
        {
          id: 3,
          name:'Minh Phúc'
        }
      ],
        listNumPerCallMinhPhuc: [0],
        listNumPerCall: [5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80]
    }
  },
  watch: {
    'listQuery.page': {
      handler() {
        console.log(1111)
        this.getList()
      },
    },
  },
  async created() {
    await this.getList()
    await this.getListCampaign()
    await this.getListSegmentCode()
  },
  computed: {
    currentDate () {
      return moment().format('YYYY-MM-DD')
    },
  },
  methods: {
      async getListSegmentCode() {
          try {
              const params = {
                  "sorts[createdAt]": "desc"
              }
              const response = await TypeRepository.listSegmentCodeApi(params)
              if(response.success) {
                  const data =_.get(response, 'data', [])
                  this.listSegment = [{ id: 0, segmentCode: "Tất cả" }].concat(data)
              }else {
                  this.listSegment = []
              }
          }catch (e) {
              console.log(e)
          }
      },
    changeSwitchBoard(item){
      this.getListCampaign(item.callCenterId)
       if(item.callCenterId == 3 ) {
           item.numPerCall = 0
       }else {
           item.numPerCall = ''
       }
    },
    getTotalItem(totalItem, limit = 10) {
      return Math.floor((totalItem - 1) / limit) + 1
    },
    checkTime(item) {
      return moment().add(5, 'minutes').isBefore(moment(item.startDate + ' ' + item.startTime))
    },
    getListTime(time = '', type= 'start') {
      const hours = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute++) {
          const hourStr = hour.toString().padStart(2, '0')
          const minuteStr = minute.toString().padStart(2, '0')
          const time = `${hourStr}:${minuteStr}`
          hours.push(time)
        }
      }
      return hours.map((hour) => ({
        id: hour,
        name: hour,
        disabled:time ? (type === 'start' ? hour >= time :  hour <= time) : false,
      }));
    },
    async getListCampaign(callCenterId = 5) {
      try {
        const response= await ContactRepository.getListCampaignOmiCall({
          callCenterId,
        })
        if(response.success) {
          this.listCampaign = response.data
        }
      }catch (e) {
        console.log(e)
      }
    },
    async getList() {
      const loading = this.$loading.show()
      try {
        const params = {
          typeId: this.$store.state.module.typeId,
          schoolLevelId: this.$store.state.module.schoolLevelId,
          page: this.listQuery.page,
          limit: this.listQuery.limit,
        }
        const response= await ContactRepository.getListCampaignApi(params)
        if(response.success) {
          this.totalItem= response.totalItem
          this.dataTable = response.data.map(item => {
            this.$set(item, 'isEdit', false)
            item.originalCareStatus = item.callCenterId
            item.originalExpectedQuantity = item.expectedQuantity
            item.originalCollectedQuantity = item.collectedQuantity
            item.originalScriptId = item.scriptId
            item.originalScriptName = item.scriptName
            item.originalStartDate = item.startDate
            item.originalStartTime = item.startTime
            item.originalEndTime = item.endTime
            item.originalNumPerCall = item.numPerCall
            item.originalSegmentId = item.segmentId
            return item
          })
        }
        loading.hide()
      }catch (e) {
        loading.hide()
        console.log(e)
      }
    },
    createData() {
      this.dataTable.unshift({ ...formData})
    },
    async updateRow(item) {
      const OMI_CALL = 5;
      if(item.callCenterId == '' || item.expectedQuantity == '' || item.scriptId== '' || item.scriptName == ''
          || item.startDate== '' || item.startTime== '' || (item.numPerCall == '' && item.callCenterId == OMI_CALL) || item.endTime == '') {
        this.$swal({
          title: 'Vui lòng nhập đầy đủ thông tin',
          icon: 'error',
        })
      }else {
        if(moment().add(10, 'minutes').isBefore(moment(item.startDate + ' ' + item.startTime))) {
          this.$swal({
            html: `<b>Bạn có chắc chắc muốn tạo chiến dịch</b><br><b>- Thời gian:</b> ${item.startTime} - ${item.endTime}, ${this.formatDateVN(item.startDate)}`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Xác nhận',
            closeOnConfirm: false,
            cancelButtonText: 'Quay lại'
          }).then(async (result) => {
            if (result.value) {
              const loading = this.$loading.show()
              try {
                const data = {
                  callCenterId: item.callCenterId,
                  expectedQuantity: item.expectedQuantity,
                  scriptId: item.scriptId,
                  scriptName: item.scriptName,
                  startDate: item.startDate,
                  startTime: item.startTime,
                  endTime: item.endTime,
                  typeId: this.$store.state.module.typeId,
                  schoolLevelId: this.$store.state.module.schoolLevelId,
                  numPerCall: item.numPerCall,
                  segmentId: item.segmentId
                }
                const response= await ContactRepository.createCampaignApi(data)
                if(response.success) {
                  item.isEdit= false
                  item.originalCareStatus = item.callCenterId
                  item.originalExpectedQuantity = item.expectedQuantity
                  item.originalCollectedQuantity = item.collectedQuantity
                  item.originalScriptId = item.scriptId
                  item.originalScriptName = item.scriptName
                  item.originalStartDate = item.startDate
                  item.originalStartTime = item.startTime
                  item.originalEndTime = item.endTime
                  item.originalNumPerCall = item.numPerCall
                  item.originalSegmentId = item.segmentId
                  this.$swal({
                    title: 'Tạo chiến dịch thành công',
                    icon: 'success',
                    confirmButtonText: 'Đồng ý',
                  })
                  this.listQuery.page= 1
                  await this.getList()
                }
                loading.hide()
              }catch (e) {
                loading.hide()
                console.log(e)
              }
            }
          });
        }else {
          this.$swal({
            html: `<b>Điều kiện tạo chiến dịch chưa đúng</b><br><br>
                            Cần tạo chiến dịch trước 10 phút`,
            icon: 'error',
          })
        }
      }
    },
    formatDateVN(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      }
      return '';
    },
    cancelUpdate(row) {
        this.dataTable.shift()
    },
    async removeRow(item) {
      this.$swal({
        html: `<b>Bạn có chắc chắc muốn xóa chiến dịch này ?</b><br><b>- Thời gian: ${item.startTime} - ${item.endTime}, ${this.formatDateVN(item.startDate)}</b>`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Xác nhận',
        closeOnConfirm: false,
        cancelButtonText: 'Quay lại'
      }).then(async (result) => {
        if (result.value) {
          console.log(111)
          try {
            const response = await ContactRepository.deleteCampaignApi(item.id)
            if (response.success) {
              this.$swal({
                title: 'Xóa chiến dịch thành công',
                icon: 'success',
              })
              await this.getList()
            } else {
              this.$swal({
                title: response.message,
                icon: 'error',
              })
            }
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    changeData(item) {
      const datePickerMenu1 = 'datePickerMenu'+this.dataTable.indexOf(item)
      console.log(this.$refs[datePickerMenu1])
      this.$refs[datePickerMenu1].save(item.startDate)
      this.datePickerMenu[this.dataTable.indexOf(item)] = false
    },
    changeExpectedQuantity: _.debounce(function(item) {
      if(item.expectedQuantity !== '') {
        if(item.expectedQuantity < 1) {
          item.expectedQuantity = 1
        }else if(item.expectedQuantity > 40000) {
          item.expectedQuantity = 40000
        }else {
          item.expectedQuantity = Math.floor(item.expectedQuantity)
        }
      }
    }, 500),
    changeScriptName(item) {
      if(item.scriptId) {
        item.scriptName= this.listCampaign.find(data => data.id === item.scriptId).name
      }else {
        item.scriptName= ''
      }
      console.log(item.scriptName, 'item.scriptName')
    }
  }
};
</script>
<style lang="scss">
.form-campaign {
  .v-text-field{
    padding-top: 0 !important;
    margin-top: 0 !important;
  }
  //table{
  //    th, td {
  //        font-size: 10px !important;
  //    }
  //}
  .theme--light.v-card.v-card--outlined {
    border: 0;
  }
  .v-expansion-panel::before {
    box-shadow: none;
  }
}
.table-campaign {
  table {
    th{
      font-weight: 600 !important;
      color:black !important;
      background: rgba(223, 222, 222, 1) !important;
      z-index: 10 !important;
    }
    td, th {
      height: 40px !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      letter-spacing: 0;
    }
    td {
      font-weight: 400 !important;
      color: #000000 !important;
      padding: 8px !important;
    }
  }
  .v-data-table__empty-wrapper {
    color: red;
  }
}
</style>